var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative",class:_vm.floatLabel ? 'float-label' : ''},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('select',_vm._b({class:{ error: _vm.error, success: _vm.success },attrs:{"id":_vm.id},domProps:{"value":_vm.value},on:{"change":_vm.handleChange}},'select',_vm.$attrs,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }